// @flow @format
import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../Logo';
import './Header.css';

import type {Node} from 'react';

type Props = {children?: Node};

const Header = ({children}: Props) =>
	<div className="Header">
		<Logo className="Header__Logo" />
		{children}
	</div>;

Header.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.node),
	]),
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js